<template>
  <MPopover
    ref="mPopoverRef"
    overlay-class-name="form-overlay"
    placement="bottomRight"
    :overlay-style="{ width: '300px' }"
    @hide="hide"
  >
    <template v-slot:trigger>
      <MButton
        variant="transparent"
        class="text-neutral"
        :shadow="false"
        shape="circle"
      >
        <MIcon name="trash-undo-alt" size="lg" class="text-secondary-green" />
      </MButton>
    </template>
    <FlotoForm @submit="handleFormSubmit">
      <FlotoFormItem :label="$tc('folder')" rules="required">
        <FolderPicker v-model="folderId" />
      </FlotoFormItem>
      <template v-slot:submit>
        <div class="text-right">
          <MButton type="submit">
            {{ $t('restore') }}
          </MButton>
        </div>
      </template>
    </FlotoForm>
  </MPopover>
</template>

<script>
import FolderPicker from './folder-picker'
export default {
  name: 'RestoreBtn',
  components: { FolderPicker },
  data() {
    return {
      folderId: undefined,
    }
  },
  methods: {
    handleFormSubmit() {
      this.$emit('confirm', this.folderId)
      this.hide()
    },
    hide() {
      this.$refs.mPopoverRef && this.$refs.mPopoverRef.hide()
      this.folderId = undefined
    },
  },
}
</script>
